import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from '@nestjs/typeorm';
import { EnquiriesController } from "./enquiry.controller";
import { EnquiriesService } from "./enquiry.service";
import { EnquiriesEntity } from "./entites/enquiries";
import { EnquiryProdctsEntity } from "./entites/enquiry-products";
import { EnquiriesRepository } from "./repositories/enquiries.repo";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { EnquiryLogEntity } from "./entites/enquiry-log";
// import {Customers} from './../../../../../services/masters/src/app/customers/address.entity'
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { CostSheetEntity } from "../costing/entity/cost-sheet-entity";
import { MFGCostsEntity } from "../costing/entity/mfg-costs-entity";
import { FreightForwardExpensesEntity } from "../costing/entity/freight-forward-expenses-entity";
import { EnquiryPackBomEntity } from "./entites/enquiry-pack-bom.entity";
import { EnquiriesProductsRepository } from "./repositories/enquiry-products-repo";

@Module({
    imports: [
      TypeOrmModule.forFeature([
        EnquiriesEntity,
        EnquiryProdctsEntity,
        EnquiriesRepository,
        EnquiryLogEntity,
        CostSheetEntity,
        EnquiryPackBomEntity,
        // MFGCostsEntity,
        // FreightForwardExpensesEntity
      ])
    ],
    controllers: [EnquiriesController],
    providers: [ApplicationExceptionHandler,EnquiriesService,LogsService,WhatsappBroadCastService,WhatsAppNotificationService,EnquiriesProductsRepository],
    exports: [EnquiriesService]
  })
  export class EnquiriesModule { }